import React, { useState } from 'react';
import axios from 'axios';

const BecomeReviewer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    institution: '',
    expertise: '',
    qualifications: '',
    publications: '',
    motivation: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/reviewer-applications', formData);
      setSubmitted(true);
    } catch (error) {
      console.error('Error submitting application:', error);
      alert('Failed to submit application. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="container mt-5">
        <div className="alert alert-success">
          <h4>Application Submitted!</h4>
          <p>Thank you for your interest in becoming a reviewer. We will review your application and contact you soon.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <h1>Become a Reviewer</h1>
      <p className="lead">Join our team of expert reviewers</p>

      <div className="row mt-4">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body">
              <h3>Reviewer Application Form</h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Full Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Institution/Organization *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="institution"
                    value={formData.institution}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Areas of Expertise *</label>
                  <textarea
                    className="form-control"
                    name="expertise"
                    rows="3"
                    value={formData.expertise}
                    onChange={handleChange}
                    placeholder="List your areas of expertise in agriculture and life sciences"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Qualifications *</label>
                  <textarea
                    className="form-control"
                    name="qualifications"
                    rows="3"
                    value={formData.qualifications}
                    onChange={handleChange}
                    placeholder="List your academic qualifications"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Recent Publications</label>
                  <textarea
                    className="form-control"
                    name="publications"
                    rows="3"
                    value={formData.publications}
                    onChange={handleChange}
                    placeholder="List your recent publications (optional)"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Motivation</label>
                  <textarea
                    className="form-control"
                    name="motivation"
                    rows="3"
                    value={formData.motivation}
                    onChange={handleChange}
                    placeholder="Why do you want to become a reviewer? (optional)"
                  />
                </div>

                <button type="submit" className="btn btn-primary">
                  Submit Application
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <h4>Why Become a Reviewer?</h4>
              <ul>
                <li>Contribute to academic excellence</li>
                <li>Stay updated with latest research</li>
                <li>Build your professional network</li>
                <li>Enhance your CV</li>
                <li>Receive reviewer certificates</li>
              </ul>

              <h4 className="mt-4">Requirements</h4>
              <ul>
                <li>PhD or equivalent experience</li>
                <li>Published research in relevant fields</li>
                <li>Commitment to timely reviews</li>
                <li>Adherence to ethical guidelines</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeReviewer;